import { render, staticRenderFns } from "./SoilNutrients.vue?vue&type=template&id=6d619b8b"
import script from "./SoilNutrients.vue?vue&type=script&lang=js"
export * from "./SoilNutrients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports